// Stands in for @tanstack/react-query in the production bundle, so that
// @termly-web/common's query hooks run on @tanstack/preact-query. Both
// packages are TanStack Query v5 and share an API, so everything passes
// through unchanged except `QueryClient`.

export * from '@tanstack/preact-query'

import { QueryClient as QueryClientV5 } from '@tanstack/preact-query'

// TanStack Query v5 wraps every query result in a Proxy (via
// queryObserver.trackResult) to track which properties the component
// reads, so it can skip re-renders when only unread properties change.
//
// The resource-blocker's query usage is simple — useLocaleStringsFile
// fetches a JSON blob once and reads `data` — so this optimization
// saves nothing here. More importantly, some customer sites load
// polyfills or libraries that overwrite the native Proxy constructor
// with a non-constructor shim (e.g. older core-js builds, SignalR
// helpers). When that happens, trackResult throws "Proxy is not a
// constructor" and the entire consent banner fails to render.
//
// Setting notifyOnChangeProps to 'all' restores v4 behavior: every
// query state change triggers a re-render, bypassing trackResult
// and its Proxy dependency entirely.
export function QueryClient(config = {}) {
  const { defaultOptions = {}, ...rest } = config
  const { queries = {}, ...otherDefaults } = defaultOptions

  return new QueryClientV5({
    ...rest,
    defaultOptions: {
      ...otherDefaults,
      queries: {
        ...queries,
        notifyOnChangeProps: 'all',
      },
    },
  })
}
